import React, { Fragment } from "react";
import axios from "axios";
import driveIcon from "../assets/google_drive_logo_small.png";

const DriveUpload = (props) => {

    var ResumeUploadHandler = function(){
        if( ResumeUploadHandler.inst ) return ResumeUploadHandler.inst;
        if( ! this instanceof ResumeUploadHandler ) return new ResumeUploadHandler();
        ResumeUploadHandler.inst = this;
        var receivedFileData = null;
        var receivedUserData = null;
        var userInfoArray = ["fname","lname","phone","email"];
        var initiatedFrom = null , textResumeData = null, uploadData = null;
        var wurl = "";

        var initResumePicker = function( startedFrom ){
          initiatedFrom = startedFrom;
        }

        var setUserData = function(data){
          receivedUserData = data;
        }

        var displayReceivedResume = function(){
          var fileDisplayName = "";
          if( receivedFileData && receivedFileData.name ){
            fileDisplayName = receivedFileData.name;
          } else {
            fileDisplayName = ( receivedUserData.fname + " " + receivedUserData.lname ).trim().replace(" ","_")+".pdf";
          }
          var resumeDisplayHtml = fileDisplayName;
          props.updateResumeFileName( resumeDisplayHtml );
        }

        var localFormatPhone = function(phoneVal){
          phoneVal = phoneVal.replace(/[^\d]/g, "");
          if (phoneVal.length === 10) {
            return phoneVal.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
          }
          return phoneVal;
        }

        var displayUserProfile = function(){
          displayReceivedResume();
            props.onFormSubmit('customForm');
          for( var i = 0; i < userInfoArray.length; i++ ){
            var cur = userInfoArray[i];
            if( receivedUserData && receivedUserData[cur] ){
              var userVal = receivedUserData[cur];
              if( cur === "phone" ){
                userVal = userVal.replace(/[^0-9]/g,'');
              }
            } else {

            }
          }
        }

        var resumeReceiveSuccess = function(data){
          if(data){receivedUserData = data;}
          displayUserProfile();
        }

        var resumeReceiveError = function(){
          userCancel();
        };

        var removeSelectedResume = function(){
          userCancel();
        }

        var userCancel = function(){
          props.hideLoad();
        }

        function resumeAvailabityOption(t){
          var selectedValue = "";
          axios.post(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins.jsp", {
            params: {
              resumeAgents : selectedValue,
              optin_advertisers : selectedValue
            }
          })
          .then(function (response) {

          })
          .catch(function (error) {
            props.hideLoad();
          })
          .then(function () {
            // always executed
          });
        }

        var continueResumeAccept = function(){
          if( initiatedFrom === "Dropbox" || initiatedFrom === "GoogleDrive"){
            props.showLoad();
            if(props.hostedType.toLowerCase() === "hosted" || props.hostedType.toLowerCase() === "hosted_plus"){
            axios.all([
              axios.post(process.env['REACT_APP_API_URL'] + "/upward/applicationSubmit.jsp?", props.queryString3),
              axios.get(process.env['REACT_APP_API_URL'] + '/upward/includes/downloadCloud.jsp', {
                params: {
                "RESUME_LINK" : receivedFileData.link,
                "FILE_NAME" : receivedFileData.name,
                "resume_source" : receivedFileData.src,
                "attachResume" : true,
                "TKN" : receivedFileData.TKN,
                },
                headers : {
                  "X-Requested-With" : "XMLHttpRequest"
                }
              })
            ])
            .then(function (response) {
              props.hideLoad();
              resumeAvailabityOption().always(function(){
                window.location.reload();
              });
            })
            .catch(function (error) {
              console.log("Resume optin option is not available;"); window.location.reload();
              props.hideLoad();
            })
            .then(function () {
              // always executed
            });
          }else{
            axios.all([
              axios.get(process.env['REACT_APP_API_URL'] + '/upward/includes/downloadCloud.jsp', {
                params: {
                "RESUME_LINK" : receivedFileData.link,
                "FILE_NAME" : receivedFileData.name,
                "resume_source" : receivedFileData.src,
                "attachResume" : true,
                "TKN" : receivedFileData.TKN,
                },
                headers : {
                  "X-Requested-With" : "XMLHttpRequest"
                }
              })
            ])
            .then(function (response) {
              props.hideLoad();
              resumeAvailabityOption().always(function(){
                window.location.reload();
              });
            })
            .catch(function (error) {
              console.log("Resume optin option is not available;"); window.location.reload();
              props.hideLoad();
            })
            .then(function () {
              // always executed
            });
          }

          }
        }

        var receiveResume = function(fileData){
          receivedFileData = fileData;
          props.showLoad();
          if(props.hostedType.toLowerCase() === "hosted" || props.hostedType.toLowerCase() === "hosted_plus"){
          axios.all([
            axios.post(process.env['REACT_APP_API_URL'] + "/upward/applicationSubmit.jsp?", props.queryString3),
            axios.get(process.env['REACT_APP_API_URL'] + '/upward/includes/downloadCloud.jsp', {
              params: {
                "RESUME_LINK" : receivedFileData.link,
                "FILE_NAME" : receivedFileData.name,
                "resume_source" : receivedFileData.src,
                "attachResume" : true,
                "TKN" : receivedFileData.TKN,
              },
              headers : {
                  "X-Requested-With" : "XMLHttpRequest"
              }
            })
          ])
          .then(function (response) {
            resumeReceiveSuccess(response);
          })
          .catch(function (error) {
            resumeReceiveError();
            props.hideLoad();
          })
        }else{
          axios.all([
            axios.get(process.env['REACT_APP_API_URL'] + '/upward/includes/downloadCloud.jsp', {
              params: {
                "RESUME_LINK" : receivedFileData.link,
                "FILE_NAME" : receivedFileData.name,
                "resume_source" : receivedFileData.src,
                "attachResume" : true,
                "TKN" : receivedFileData.TKN,
              },
              headers : {
                  "X-Requested-With" : "XMLHttpRequest"
              }
            })
          ])
          .then(function (response) {
            resumeReceiveSuccess(response);
          })
          .catch(function (error) {
            resumeReceiveError();
            props.hideLoad();
          })
        }
        }
        function localSetQuery() {
          var domainOut = window.location.hostname;
          domainOut = domainOut.replace("www.","").replace("stage.","");
          var jobInternalPost = "";
          var locationUsed = "";
          var query = {
            "CID": props.cid,
            "SID": props.sid,
            "job": jobInternalPost,
            "location":locationUsed,
            "job_title":jobInternalPost,
            "degree_held":"",
            "counselor":"",
            "graduation_year":"",
            "siteId": props.siteId,
            "domain":domainOut,
            "keyMapId": props.keyMapId,
            "LOOKUP":"homeCarrier",
            "return_url":process.env['REACT_APP_API_URL']+"/upward/resultsRedirect.jsp"
          }
        }
        function localInternalPost(w) {
              var queryOut = localSetQuery();
              if (w === 'signup') {
                wurl = process.env['REACT_APP_API_URL'] + "/upward/accountSignup.jsp?OID=3002";
              } else if (w === 'sms') {
                wurl = process.env['REACT_APP_API_URL'] + '/upward/smsActions.jsp?OID=2984&CID=&SID=&enabled=y&phone=';
              }else if (w === 'post') {
                  wurl = process.env['REACT_APP_API_URL'] + '/search/internalPost2.fsn?OID=3002&CRID=';
              } else {
                  wurl = process.env['REACT_APP_API_URL'] + '/search/internalPost2.fsn?OID='+w+'&CRID=';
              }
          }

        var continueAfterUserSignUp = function(){

          displayReceivedResume();
        }

        var setTextResume = function(data){
          textResumeData = data;
        }

        var setUploadData = function(data){
          uploadData = data;
        }

        var createAccount = function(){
          var obj = {};
          receivedUserData = obj;
          localInternalPost('signup')
                  .always( function(data,textStatus,jqXHR){
                      return localInternalPost('post')
                  })
                  .always( function(data,textStatus,jqXHR){
                      return localInternalPost('sms')
                  })
            .always( function(data,textStatus,jqXHR){
              continueAfterUserSignUp();
            });
        }
        return {
          initResumePicker : initResumePicker,
          receiveResume : receiveResume,
          userCancel : userCancel,
          removeSelectedResume : removeSelectedResume,
          continueResumeAccept : continueResumeAccept,
          createAccount : createAccount,
          setUserData : setUserData,
          resumeReceiveSuccess : resumeReceiveSuccess,
          setTextResume : setTextResume,
          setUploadData : setUploadData
        }
      }
    var resumeHandler = new ResumeUploadHandler();

      var developerKey = 'AIzaSyBeKulZ5RBh0QCSNJeRye7LAzdtTgb9bjc';

        //***DEV KEY***
      var clientId = window.location.href.indexOf("stage.") > -1 || window.location.href.indexOf("stage1.") > -1 ? '776270215531-a0c2r5hphctbeei8l6gbcmt806stkq2o.apps.googleusercontent.com' : '776270215531-a0qdsgircf2vkjphsj7obo03h7tlkgbf.apps.googleusercontent.com';
      var appId = '776270215531';

      // Scope to use to access user's documents.
      var scope = 'https://www.googleapis.com/auth/drive.readonly';

      var pickerApiLoaded = false;
      var oauthToken;

      // Use the API Loader script to load google.picker and gapi.auth.
      function onApiLoad() {
        window.gapi.load('auth2', onAuthApiLoad);
        window.gapi.load('picker', onPickerApiLoad);
      }

      function onAuthApiLoad() {
          window.gapi.auth2.authorize({
            client_id: clientId,
            scope: scope
          }, handleAuthResult);
      }

      function onPickerApiLoad() {
        pickerApiLoaded = true;
        createPicker();
      }

      function handleAuthResult(authResult) {
        if (authResult && !authResult.error) {
          oauthToken = authResult.access_token;
          createPicker();
        }
      }

      // Create and render a Picker object for picking user Documents.
      function createPicker() {
        if (pickerApiLoaded && oauthToken) {
          resumeHandler.initResumePicker("GoogleDrive");
          //var view = new google.picker.DocsView();
          //view.setParent("root"); // optional
          //view.setIncludeFolders(true); // optional
          var view = new window.google.picker.View(window.google.picker.ViewId.DOCS);
          view.setMimeTypes("application/vnd.google-apps.document,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/html,application/pdf,text/plain");
          var picker = new window.google.picker.PickerBuilder().
              addView(view).
              setAppId(appId).
              setOAuthToken(oauthToken).
              setDeveloperKey(developerKey).
              setCallback(pickerCallback).
              setTitle("Select your resume file(doc,docx or pdf)").
              setMaxItems(1).

              build();
          picker.setVisible(true);
        }
      }

      // A simple callback implementation.
      function pickerCallback(data)
      {
        var link = 'https://www.googleapis.com/drive/v2/files/';
        if (data[window.google.picker.Response.ACTION] === window.google.picker.Action.PICKED){
            var doc = data[window.google.picker.Response.DOCUMENTS][0];
            var name = doc[window.google.picker.Document.NAME];
            var mime = doc[window.google.picker.Document.MIME_TYPE];
            var id = doc[window.google.picker.Document.ID];
            if (mime === "application/vnd.google-apps.document")
            {
                name = name + ".pdf";
                //https://www.googleapis.com/drive/v3/files/fileId/export
                link =  link + id + '/export?mimeType=application/pdf';
            }
            else
            {
                link =  link + id + '?alt=media'
            }
            var fileData = {};
            fileData.name = name;
            fileData.src = "GOOGLE_DRIVE";
            fileData.link = link;
            fileData.TKN = oauthToken
            resumeHandler.receiveResume(fileData);
        }
        if (data[window.google.picker.Response.ACTION] === window.google.picker.Action.CANCEL){
            resumeHandler.userCancel();
        }
      }


    return (
        <Fragment>
             <button onClick={() => onApiLoad()} type="button" className="btn btnClear btnBordered resumeSelectButton btnSmall btn-sm"><img src={driveIcon} alt="Google Drive" /> Google Drive</button>
             <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
        </Fragment>
    )

}

export default DriveUpload;
